import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getProfessionsRequest from './getProfessions.repository';

type InitialState = {
  loading: boolean;
  data?: string[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getProfessions = createAsyncThunk('getProfessions', async () => {
  return await getProfessionsRequest();
});

const getProfessionsSlice = createSlice({
  name: 'getProfessions',
  initialState,
  reducers: {
    getProfessionsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProfessions.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getProfessions.fulfilled,
      (state, action: PayloadAction<string[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getProfessions.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getProfessionsSlice.reducer;
export const { getProfessionsReset } = getProfessionsSlice.actions;
